import { Icon, IconAttention } from '@flixbus/honeycomb-icons-react';

import styles from './styles.module.css';

const SHIFT_TIME_TOO_LONG_TEXT = {
	title: 'Shift time too long',
	description: 'The selected time range is too long. Please shorten the shift and try again.',
};

const WATooLongShiftErrorBanner = () => {
	return (
		<div className={styles.longShiftTimeBanner}>
			<div className={styles.headerBlock}>
				<Icon extraClasses={styles.danger} InlineIcon={IconAttention} size={4} />
				<div className={styles.descriptionBlock}>
					<div className={styles.bold}>{SHIFT_TIME_TOO_LONG_TEXT.title}</div>
					<div>{SHIFT_TIME_TOO_LONG_TEXT.description}</div>
				</div>
			</div>
		</div>
	);
};

export default WATooLongShiftErrorBanner;
